import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useQuery } from '../hooks/useQuery';
import CircularProgress from '@mui/material/CircularProgress';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import 'moment/locale/pt-br';
import AddIcon from '@mui/icons-material/Add';
import { TextField } from '@mui/material';

export const CalendarioPage = (props) => {
  const { listarCalendario, deletarCalendario } = useQuery();
  const [calendarios, setCalendarios] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const navigate = useNavigate();
  const theme = useTheme();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const deletar = async (id) => {
    setLoading(true);

    const result = await deletarCalendario(id);

    if (result && result.data) {
      console.log(result.data.data);
      listar();
    }

    setLoading(false);
  };

  const onSubmitSearch = (e) => {
    e.preventDefault();

    listar();
  };

  const listar = async () => {
    setLoading(true);

    const result = await listarCalendario(`?search=${search}`);

    if (result && result.data) {
      setCalendarios(result.data.data);
    }

    setLoading(false);
  };

  React.useEffect(() => {
    listar();
  }, []);

  return (
    <Box
      mt={8}
      sx={{ width: '100%', minHeight: '100vh' }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Calendário de notas
              </span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12} display="flex" justifyContent="flex-end">
          <Button
            onClick={() => {
              navigate(`/dashboard/criar-calendario`);
            }}
            variant="contained"
            startIcon={<AddIcon />}
          >
            Novo Calendário
          </Button>
        </Grid>
        <Grid item sm={12} display="flex">
          <form
            style={{ width: '100%', marginTop: '0.5rem' }}
            onSubmit={onSubmitSearch}
          >
            <TextField
              placeholder="Pesquisar por ano..."
              fullWidth
              value={search}
              onChange={({ target }) => setSearch(target.value)}
            />
          </form>
        </Grid>
        <Grid item sm={12} width="100%">
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress style={{ marginTop: 60 }} />
            </Box>
          ) : (
            <div style={{ width: '100%', overflowY: 'scroll' }}>
              <table className="app_table">
                <thead
                  style={{
                    color: theme.palette.primary.main,
                    borderTop: `8px solid ${theme.palette.primary.light}`,
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: '10%',
                      }}
                    >
                      Data
                    </th>

                    <th
                      style={{
                        width: '20%',
                      }}
                    >
                      Permite Envio
                    </th>
                    <th
                      style={{
                        width: '20%',
                      }}
                    >
                      Alterado por
                    </th>
                    <th
                      style={{
                        width: '15%',
                      }}
                    ></th>
                    <th
                      style={{
                        width: '15%',
                      }}
                    ></th>
                  </tr>
                </thead>

                <tbody>
                  {calendarios &&
                    calendarios.length > 0 &&
                    calendarios.map((calendario, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: 'left' }}>
                          {calendario.formatted_date}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {calendario.permite_envio == 'N' ? 'Não' : 'Sim'}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {calendario.last_user}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              navigate(
                                `/dashboard/criar-calendario?calendario_id=${calendario.id}`,
                              );
                            }}
                            style={{ width: '100%', marginTop: 10 }}
                          >
                            Editar
                          </Button>
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => deletar(calendario.id)}
                            style={{ width: '100%', marginTop: 10 }}
                          >
                            Excluir
                          </Button>
                        </td>
                      </tr>
                    ))}
                  {!loading && calendarios && calendarios.length == 0 ? (
                    <tr>
                      <td colSpan={5} align="center">
                        Nenhum Calendario encontrado.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
